import { collection, limit, onSnapshot, query, where } from "firebase/firestore"
import { useEffect, useState } from "react"
import { useSetRecoilState } from "recoil"
import useSWR from "swr"
import { currectOrderAtom } from "../config/atoms"
import { db } from "../config/firebase"

export default function useIncoming() {

    const [data, setData] = useState(false)
    const setCurrentOrder = useSetRecoilState(currectOrderAtom)

    const fetcher = async () => {
        try {

            if(!data) {
                return null;
            }
            
            if(data) {
                const audio = document.getElementById('alert-audio')
                if(audio) {
                    audio.play()
                }
            }
           
        } catch(err) {
            console.log(err)
        }
    }

    useSWR("/new-store-order", fetcher, {
        isPaused: () => false,
        refreshInterval: 5000
    })

    useEffect(() => {

        const q = query(
            collection(db, "orders"),
            where("status", "==", "pending"),
            limit(1)
        )

        return onSnapshot(q, {
            next: async ({ docs }) => {
                setData(null)
                
                let ordersList = []
                for await (const doc of docs) {
                    const data = doc.data().data
                    ordersList = [ ...ordersList, { ...data, id: doc.id } ]
                } 
                setCurrentOrder(ordersList[0])
                setData(ordersList[0] ? true : false)
                
            },
            error: console.log
        })
    
      
    }, [])

    return data
}